import { IconButton, ListItemIcon, Menu, MenuItem, Paper, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { ReportJobTypes } from '@weft/types';
import { isNotNullOrUndefined, type Nullable } from '@weft/utils';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import type { ReportType } from '../reports-page-types/report-type';
import { REPORT_TYPES } from '../reports-page-types/report-type';
import { getSelectedReportJobForm } from '../reports-page-utils/get-selected-report-form';
import { TriggerReportJobForm } from './trigger-report-job-dialog/TriggerReportJobDialog';

type ReportMenuProps = {
  selectedReportJob?: ReportJobTypes;
  reportType: Nullable<ReportType>;
  onExportCsv?: () => void;
  shouldExportAsCsv: boolean;
  shouldRequestReport: boolean;
};
    
export const ReportMenu: React.FC<ReportMenuProps> = ({ selectedReportJob, reportType, onExportCsv, shouldExportAsCsv, shouldRequestReport }) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();
  
  const disableRequestReport: ReportType[] = [
    REPORT_TYPES.CUSTOMER_REVENUE,
    REPORT_TYPES.CONTRACTS,
    REPORT_TYPES.ANONYMOUS_CUSTOMERS,
    REPORT_TYPES.MONTHLY_CLOUSER,
  ];

  return (
    <>
      <IconButton
        size='medium'
        onClick={handleMenuOpen}
      >
        <VyIcon icon="DotsMenu"/>
      </IconButton>

      <Menu
        anchorEl={anchorElement}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={isOpen}
        onClose={handleMenuClose}
        MenuListProps={{
          className: 'py-0',

        }}
        slotProps={{
          paper: {
            className: 'max-w-[250px] w-full shadow-xl',
          },
        }}
      >
        <Paper elevation={8}>
          {isNotNullOrUndefined(selectedReportJob) && shouldRequestReport && (
            <TriggerReportJobForm
              reportJobType={selectedReportJob}
              disabled={isNotNullOrUndefined(reportType) && disableRequestReport.includes(reportType)}
              formContent={selectedReportJob ? (props) => getSelectedReportJobForm(selectedReportJob, props) : undefined}
            />
          )}

          {shouldExportAsCsv && (
            <MenuItem
              sx={{ height: '50px !important' }}
              onClick={() => onExportCsv?.()}
            >
              <ListItemIcon>
                <VyIcon icon="Csv" />
              </ListItemIcon>
              <Typography
                fontSize={16}
                fontWeight={350}
              >
                Download as CSV
              </Typography>
            </MenuItem>
          ) }
        </Paper>
      </Menu>
    </>
  );
};
